/**
 * 音频转文字（`audio_transcribe`）provider 的**唯一真相源**：合法值域 + 推荐链序 +
 * 「下一条该加谁」。
 *
 * 与 {@link ./web-search-providers.js} 同律、同住 shared，判据也一样：消费方跨了依赖
 * 方向的两端——
 *  · `@dosia/core` —— 运行时按这份值域过滤策展下发的链、按这份序做兜底；
 *  · `apps/admin-portal-web` —— 超管配链的下拉选项与「+ 添加」按钮（该 app **只**依赖
 *    shared，不依赖 core）；
 *  · `packages/shared` 自己 —— `PlatformToolCuration.audioTranscribeProviders` 的类型与
 *    `buildPlatformToolCuration` 的落库清洗白名单。
 *
 * **加一条腿要填哪几格：以 `pnpm typecheck` 的报错为准**，本文件刻意不复述格子数——那是
 * 同一事实的第二份副本，必漂移（web_search 那份清单自己就漏过一格，见该文件头注）。派生的
 * `Record<所有 id, …>` 少任何一格都是编译失败，而不是运行时静默，这正是把值域收成一处要买
 * 的东西。
 */
/**
 * 全部合法 provider id，**顺序即推荐链序**。
 *
 *  1. `volc_asr` —— 火山引擎「豆包语音」录音文件识别**极速版**，经**网关代理**
 *     （`/v1/audio/transcriptions`，OpenAI Audio multipart 形状）。排第一的判据是
 *     **形状**不是价格：它是专职 ASR，同步返回，且支持直接传音频 URL（不必把字节搬到
 *     本机再上传）；单次可收 ≤100MB / ≤2h 的音频，远超大模型 inline 的量级。
 *  2. `gemini_model` —— 网关组里「能听音频」的 Gemini 模型，走 `generateContent` +
 *     `inline_data`。排第二是因为两条硬约束：inline 单请求 ≈18MB 上限（超了要先切片，
 *     本期不做），以及它是**通用大模型转写**——没有逐句时间戳，长音频更容易概括而不是逐字
 *     转写。它的价值在于「火山没配 / 火山这次失败」时仍有一条能出文字的腿。
 *
 * **两条腿的凭证拓扑今天完全同构**（REQ-268 起）：都从 gateway **组**解出 baseUrl/apiKey，
 * 所以策展里**每条腿都必须带非空 group**，没有例外——`volc_asr` 曾经是「Integrations 里
 * 一把厂商密钥、不走组」的特例，那条路径已整条退役。
 *
 * **同一个 provider 在一条链里只取第一条**（`buildPlatformToolCuration` 落库时按 provider
 * 去重，保首次出现的那行）：链是「按顺序换腿重试」，同一条腿排两次的第二次必然与第一次同
 * 因失败，只会在 attempts 里刷出一条重复的失败原因。
 *
 * **真正的链序权威在超管策展**（`PlatformToolCuration.audioTranscribeProviders` 有序），
 * 这份只是推荐序与合法值域，不是第二个真相源——运行时永远按策展给的顺序走。个人版不吃策展，
 * 缺省即本数组的顺序，组名从 bundle 行自己的 `chosenGroup` 取。
 */
export const AUDIO_TRANSCRIBE_PROVIDERS_IN_PREFERENCE_ORDER = [
    "volc_asr",
    "gemini_model",
];
export function isAudioTranscribeProviderId(v) {
    return (typeof v === "string" &&
        AUDIO_TRANSCRIBE_PROVIDERS_IN_PREFERENCE_ORDER.includes(v));
}
//# sourceMappingURL=audio-transcribe-providers.js.map